import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DirectivesModule } from 'app/directives/directives.module';
import { BackdropModule } from 'components/backdrop/backdrop.module';
import { FcpButtonModule } from 'fc-ui-components';
import { ResponsiveWrapperModule } from '../../../../components/responsive-wrapper/responsive-wrapper.module';
import { SingleStoreModalForCopyingModule } from '../single-store-modal-for-copying/single-store-modal-for-copying.module';
import { SingleStoreModalModule } from '../single-store-modal/single-store-modal.module';
import { StoreDropdownComponent } from './store-dropdown.component';
import { StoresModalModule } from '../stores-modal/stores-modal.module';

@NgModule({
    declarations: [StoreDropdownComponent],
    imports: [
        FcpButtonModule,
        StoresModalModule,
        SingleStoreModalModule,
        CommonModule,
        BackdropModule,
        ResponsiveWrapperModule,
        DirectivesModule,
        TranslateModule,
        SingleStoreModalForCopyingModule
    ],

    exports: [StoreDropdownComponent]
})
export class StoreDropdownModule {}
